import { SessionProvider } from 'next-auth/react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import store, { persistor } from '../store/store'
import '../styles/globals.css'
import type { AppProps } from 'next/app'
import { Poppins } from 'next/font/google'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { HeroUIProvider } from '@heroui/react'
import 'leaflet/dist/leaflet.css'
import SessionHandler from '@/components/SessionHandler'
import { useEffect, useState } from 'react'
import dynamic from 'next/dynamic'
const ProgressBar = dynamic(
  () => import('next-nprogress-bar').then((mod) => mod.AppProgressBar),
  {
    ssr: false,
  },
)
const poppins = Poppins({
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-poppins',
  weight: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
})

export default function App({
  Component,
  pageProps: { session, ...pageProps },
}: AppProps) {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  if (!isMounted) return null

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <SessionProvider session={session}>
          <SessionHandler />
          <div className={poppins.className}>
            <HeroUIProvider>
              <ProgressBar
                height="4px"
                color="#fffd00"
                options={{ showSpinner: false }}
                shallowRouting
              />
              <Component {...pageProps} />
            </HeroUIProvider>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </SessionProvider>
      </PersistGate>
    </Provider>
  )
}
